import React, { useState,useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from '@material-ui/core/CircularProgress';
import VizSensor from "react-visibility-sensor";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableFooter,
  TableRow,
  TableSortLabel ,
  Typography,
  IconButton,  
  Button,
  Paper,
  Chip
} from "@material-ui/core";
import CompanyLogo from "../../Common/CompanyLogo";
import ProductImage from "../../Common/ProductImage";
// import BProductsAndCompetitorPanel from "./Products/BProductsAndCompetitorPanel";


import { useSelector } from "react-redux";
import axios from "axios";
import envConfig from "../../../bin/env.config";
const useStyles = makeStyles((theme) => ({
  notMatchButton: {
    color: "red",
    borderColor: "red",
  },
  productLink:{
    textDecoration: 'none',
    color: theme.palette.primary.main,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center"
  },
  groupLink:{
    textDecoration: 'none',
    color: theme.palette.secondary.main,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center"
  } 
}));

function RowItem({ item, classes, isLoading, handleWrongLocal, handleMatchesLocal }) {
  return (
    <TableRow>
      <TableCell style={{width:'100px'}} colSpan={2} align="center">
        <CompanyLogo company_id={item.company_id} style={{ height: "30px" }}                  
        />    
      </TableCell>
      <TableCell style={{width:'80px'}}>
        <ProductImage   product_id={item.product_id} 
            title={item.product_fullname} width={'50px'} height={'50px'}  hide_multiple_icon="true"
          />
      </TableCell>
      <TableCell style={{width:'50px'}}>
        {item.product_id &&(    
          <a
          href={`/product/${item.product_id}`}
          target="_blank"
          className={classes.productLink} 
        >
          {`ID:#${item.product_id}`}
        </a> 
        )}
      </TableCell>
      <TableCell >
        {item.product_fullname}<br/>
        {item.product_size}<br/>
        <span style={{fontWeight:'bold', color:'red'}}>S: {item.cosine_similarity}</span>
      </TableCell>
      <TableCell style={{width:'50px'}}>   
        {item.product_matching_group_id &&(  
          <a
            href={`/matching-group/${item.product_matching_group_id}`}
            target="_blank"
            className={classes.groupLink} 
          >
            {`G#${item.product_matching_group_id}`}
          </a>                        
        )}
      </TableCell>          
      <TableCell style={{width:'260px', whiteSpace:'nowrap'}} align="left">
        <Button
            variant="outlined"
            size="small"
            className={classes.notMatchButton}
            onClick={()=>handleWrongLocal(item)}
            disabled={isLoading}
          >
            Wrong
          </Button>&nbsp;
          <Button
            variant="contained"
            size="small"
            className={classes.removeAcceptedButton}
            onClick={()=>handleMatchesLocal(item)}
            disabled={isLoading}
            color="secondary"
          >
            Matches
          </Button>
      </TableCell>                                    
    </TableRow>
  );
}

export default function BPotentialPanel({item,reloadDataCount,setReloadDataCount}) {  
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [reloadDataLocal, setReloadDataLocal] = useState(reloadDataCount);
  const [dataSource, setDataSource] = useState({
    product_matching_group_suggestions: [],
    product_suggestions: []
  });
  const token = useSelector((state) => state.session.token);
  const [isVisible, setIsVisible] = useState(false);
  const doLoadData = (isVisibleChanged) => {
    isVisibleChanged&&setIsVisible(isVisibleChanged)    
  };  
 
  useEffect(() => {
    
    const fetchData = async () => {
      setIsLoading(true);
      const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/product/potential/get-pmg-product-suggestions?id=${item.id}`;
      const result = await axios.post(url,{reloadDataCount:reloadDataLocal}, {
        headers: {
          Authorization: token,
        },
      });
      
      setDataSource({
        product_matching_group_suggestions: result.data.data?.product_matching_group_suggestions || [],
        product_suggestions: result.data.data?.product_suggestions || []
      });
      setIsLoading(false);
    };
    isVisible&&fetchData();
  }, [reloadDataLocal,isVisible]);
  const handleWrongLocal = (potentialItem) => {   
    setIsLoading(true);
    const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/product/potential/mark-wrong`;
    const postData = {
      company_report_tool_product_id: item.id,
      product_id: potentialItem.product_id,
      product_matching_group_id: potentialItem.product_matching_group_id
    };
    // console.log(postData);
    axios
      .post(url, postData, {
        headers: {
        Authorization: JSON.stringify(token),
        },
      })
      .then(() => {   
        setReloadDataLocal(reloadDataLocal+1);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });     
  };
  const handleMatchesLocal = (potentialItem) => {
    setIsLoading(true);
    const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/product/potential/mark-matched`;
    const postData = {
      company_report_tool_product_id: item.id,
      product_id: potentialItem.product_id,
      product_matching_group_id: potentialItem.product_matching_group_id
    };
    // console.log(postData);
    axios
      .post(url, postData, {
        headers: {
        Authorization: JSON.stringify(token),
        },
      })
      .then(() => {        
        setReloadDataLocal(reloadDataLocal+1);          
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setReloadDataCount&&setReloadDataCount(reloadDataCount+1);
        setIsLoading(false);
      });   
  };
  return (
      <VizSensor onChange={doLoadData}>    
        <Table>
          <TableBody> 
            {isLoading&&(
              <TableRow >
                <TableCell colSpan={7} align="center">
                    <CircularProgress size={16} />
                </TableCell>
              </TableRow>
            )}
            {!isLoading&&(
              <>
                {(!dataSource.product_matching_group_suggestions || dataSource.product_matching_group_suggestions.length==0)&&(
                  <TableRow >
                    <TableCell colSpan={7} align="center">
                        No potential matching product matching group suggestions
                    </TableCell>
                  </TableRow>
                )} 
                {dataSource.product_matching_group_suggestions && dataSource.product_matching_group_suggestions.map((item, i) => (               
                  <RowItem 
                    key={i}
                    item={item}
                    classes={classes}
                    isLoading={isLoading}
                    handleWrongLocal={handleWrongLocal}
                    handleMatchesLocal={handleMatchesLocal}
                  />
                ))}
                {(!dataSource.product_suggestions || dataSource.product_suggestions.length==0)&&(
                  <TableRow >
                    <TableCell colSpan={7} align="center">
                        No potential matching product suggestions
                    </TableCell>
                  </TableRow>
                )} 
                {dataSource.product_suggestions && dataSource.product_suggestions.map((item, i) => (               
                  <RowItem 
                    key={i}
                    item={item}
                    classes={classes}
                    isLoading={isLoading}
                    handleWrongLocal={handleWrongLocal}
                    handleMatchesLocal={handleMatchesLocal}
                  />
                ))}
             </>
            )}
          </TableBody>
        </Table>
    </VizSensor>   
  );
}
